module.exports = __webpack_public_path__ + "img/31.11d0df2a.png";